module.exports = __webpack_public_path__ + "img/Group4219.defaba8d.png";